import { LogoutIcon } from "@heroicons/react/outline";
import useLogout from "@/hooks/useLogout";

export default function LogoutButton() {
  const logout = useLogout();

  return (
    <button
      onClick={logout}
      className="w-full group px-3 py-2 flex items-center text-sm font-medium text-gray-900 hover:bg-gray-50"
    >
      <LogoutIcon
        className="ml-[1px] mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500"
        aria-hidden="true"
      />
      <span className="capitalize">Log Out</span>
    </button>
  );
}
